export class MailDTO {
  mail: string;
}
